import React from "react";
import {
    Button,
    Card,
    CardContent,
    Collapse,
    Grid,
    MenuItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";

const SKUFilters = ({
    open = false,
    filters = {},
    visibility = "visible",
    skuPresence = "all",
    binPresence = "all",
    onFiltersChange = () => {},
    onVisibilityChange = () => {},
    onSkuPresenceChange = () => {},
    onBinPresenceChange = () => {},
    onClearFilters = () => {},
}) => {
    const handleFilterFieldChange = (fieldName, fieldValue) => {
        onFiltersChange({
            ...filters,
            [fieldName]: fieldValue,
        });
    };

    return (
        <Collapse in={open}>
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">Filtros</Typography>
                        <Button size="small" onClick={onClearFilters}>Limpiar filtros</Button>
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="SKU"
                                value={filters.filter_sku || ""}
                                onChange={(event) => handleFilterFieldChange("filter_sku", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Código de barra"
                                value={filters.filter_barcode || ""}
                                onChange={(event) => handleFilterFieldChange("filter_barcode", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Retail"
                                value={filters.filter_retail_name || ""}
                                onChange={(event) => handleFilterFieldChange("filter_retail_name", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Código retail"
                                value={filters.filter_retail_barcode || ""}
                                onChange={(event) => handleFilterFieldChange("filter_retail_barcode", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Escaneado desde"
                                InputLabelProps={{ shrink: true }}
                                value={filters.last_scanned_from || ""}
                                onChange={(event) => handleFilterFieldChange("last_scanned_from", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Escaneado hasta"
                                InputLabelProps={{ shrink: true }}
                                value={filters.last_scanned_to || ""}
                                onChange={(event) => handleFilterFieldChange("last_scanned_to", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <TextField
                                fullWidth
                                size="small"
                                type="number"
                                label="Días manual desde"
                                value={filters.manual_days_min || ""}
                                onChange={(event) => handleFilterFieldChange("manual_days_min", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <TextField
                                fullWidth
                                size="small"
                                type="number"
                                label="Días manual hasta"
                                value={filters.manual_days_max || ""}
                                onChange={(event) => handleFilterFieldChange("manual_days_max", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Visibilidad"
                                value={visibility}
                                onChange={(event) => onVisibilityChange(event.target.value)}
                            >
                                <MenuItem value="visible">Solo visibles</MenuItem>
                                <MenuItem value="hidden">Solo ocultos</MenuItem>
                                <MenuItem value="all">Todos</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Filtro SKU"
                                value={skuPresence}
                                onChange={(event) => onSkuPresenceChange(event.target.value)}
                            >
                                <MenuItem value="all">Todos</MenuItem>
                                <MenuItem value="with_sku">Con SKU</MenuItem>
                                <MenuItem value="without_sku">Sin SKU</MenuItem>
                            </TextField>
                        </Grid>

                        {/* "Qué productos todavía no tienen posición" es la
                            pregunta con la que arranca cualquier bodega que
                            recién carga el mapa. */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Posición"
                                value={binPresence}
                                onChange={(event) => onBinPresenceChange(event.target.value)}
                            >
                                <MenuItem value="all">Todas</MenuItem>
                                <MenuItem value="with_bin">Con posición</MenuItem>
                                <MenuItem value="without_bin">Sin posición</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Collapse>
    );
};

export default SKUFilters;
